export const ACCEPT = 'Accept!';
export const REJECT = 'Reject!';


// WEBPACK FOOTER //
// ./src/constants/inputMessageTypes.js